// Add class to footer address item
document.addEventListener("DOMContentLoaded", function() {
    const footerContactLinks = document.querySelectorAll('.footer-block__details-content a');
    footerContactLinks.forEach((link)=> {
        const addressLink = link.querySelector('span');
        if (addressLink && addressLink.textContent.includes('Laval')){
            link.classList.add('address-link');
        }
    });

    const allCartItems = document.querySelectorAll('cart-drawer-items .cart-item');
    allCartItems.forEach((item) => {
      const itemImage = item.querySelector('.cart-item__image');
      const sampleProductOptions = item.querySelectorAll('.cart-item__details .product-option');
    
      if (sampleProductOptions) {
        sampleProductOptions.forEach((option) => {
          const label = option.querySelector('dt');
          const link = option.querySelector('dd');
    
          if (label && label.innerHTML.includes('Image') && link) {
            // Hide the sample product option and update the image source
            option.classList.add('hidden-sample-link');
            if (itemImage) {
              // Ensure the link has "//" at the start
              const cleanedSrc = link.textContent.trim();
              const updatedSrc = cleanedSrc.startsWith('//') ? cleanedSrc : `//${cleanedSrc}`;
              itemImage.setAttribute('src', updatedSrc);
            }
          }
        });
      }
    });
    
    const englishSearchResults = document.querySelectorAll('html[lang="en"] .template-search li.template-search__item.article');
    const frenchSearchResults = document.querySelectorAll('html[lang="fr"] .template-search li.template-search__item.article');
    
    if (englishSearchResults.length > 0) {
        englishSearchResults.forEach((result) => {
            const resultLink = result.querySelector('.article__info-link');
            if (resultLink && resultLink.getAttribute('href').includes('tendances-et-astuces')) {
                result.style.display = 'none';
            }
        });
    }
    
    if (frenchSearchResults.length > 0) {
        frenchSearchResults.forEach((result) => {
            const resultLink = result.querySelector('.article__info-link');
            if (resultLink && resultLink.getAttribute('href').includes('trends-tips')) {
                result.style.display = 'none';
            }
        });
    }
    



      });

// breadcrumb positioning on design pro and services pages
document.addEventListener("DOMContentLoaded", function() {
    const breadcrumb = document.querySelector('.template-page-programme-design-pro .breadcrumb_border');
    const designServicesBreadcrumb = document.querySelector('.template-page-services-residentiels .breadcrumb_border');
    const commercialServicesBreadcrumb = document.querySelector('.template-page-services-commerciaux .breadcrumb_border');
    const careersBreadcrumb = document.querySelector('.template-page-carrieres-1 .breadcrumb_border');
    const contactBreadcrumb = document.querySelector('.template-page-contact .breadcrumb_border');
    const aboutBreadcrumb = document.querySelector('.template-page-a-propos .breadcrumb_border');
    const escaliersBreadcrumb = document.querySelector('.template-collection-escaliers .breadcrumb_border');
    const announcement = document.querySelector('.section-announcement');
    const headerGroup = document.querySelector('.shopify-section-group-header-group');

    let offsetTop = 60;
    if (announcement) {
        offsetTop += announcement.offsetHeight;
    }
    if (headerGroup) {
        offsetTop += headerGroup.offsetHeight;
    }
    if (breadcrumb) {
        breadcrumb.style.position = 'absolute';
        breadcrumb.style.top = offsetTop + 'px';
        breadcrumb.style.width = '100%'; 
        breadcrumb.style.zIndex = '10';  
    }
    if (designServicesBreadcrumb) {
        designServicesBreadcrumb.style.position = 'absolute';
        designServicesBreadcrumb.style.top = offsetTop + 'px';
        designServicesBreadcrumb.style.width = '100%'; 
        designServicesBreadcrumb.style.zIndex = '10';  
    }
    if (commercialServicesBreadcrumb) {
        commercialServicesBreadcrumb.style.position = 'absolute';
        commercialServicesBreadcrumb.style.top = offsetTop + 'px';
        commercialServicesBreadcrumb.style.width = '100%'; 
        commercialServicesBreadcrumb.style.zIndex = '10';  
    }
    if (contactBreadcrumb) {
        contactBreadcrumb.style.position = 'absolute';
        contactBreadcrumb.style.top = offsetTop + 'px';
        contactBreadcrumb.style.width = '100%'; 
        contactBreadcrumb.style.zIndex = '10';  
    }
    if (aboutBreadcrumb) {
        aboutBreadcrumb.style.position = 'absolute';
        aboutBreadcrumb.style.top = offsetTop + 'px';
        aboutBreadcrumb.style.width = '100%'; 
        aboutBreadcrumb.style.zIndex = '10';  
    }
    if (careersBreadcrumb) {
        careersBreadcrumb.style.position = 'absolute';
        careersBreadcrumb.style.top = offsetTop + 'px';
        careersBreadcrumb.style.width = '100%'; 
        careersBreadcrumb.style.zIndex = '10';  
    }
    if (escaliersBreadcrumb) {
        escaliersBreadcrumb.style.position = 'absolute';
        escaliersBreadcrumb.style.top = offsetTop + 'px';
        escaliersBreadcrumb.style.width = '100%'; 
        escaliersBreadcrumb.style.zIndex = '10';  
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const form = document.querySelector('form#DesignProForm');
    const submitButton = document.querySelector('form#DesignProForm .button--primary');
  
    if (form && submitButton) {
      submitButton.addEventListener('click', function() {
        const style = document.createElement('style');
        style.innerHTML = `
          input:invalid {
            border: 1.5px solid #fb303c !important;
          }
        `;
        document.head.appendChild(style);
      });
    }

// hiding home collection from all collections page
const allCollections = document.querySelectorAll('body.template-list-collections ul.collection-product-list li');
allCollections.forEach((collection) => {
    const link = collection.querySelector('a[href="/collections/frontpage"]');
    if (link){
        collection.style.display = 'none';
    }  
})

// Adding line animation to richtext element 
const richtextLink = document.querySelectorAll('.richtext-content.long-line a');
richtextLink.forEach((link) => {
    link.classList.add('button-2')
})

});

  // checking window width and applying scroll behavior 
function handleSearchVisibility() {
    // const searchBtn = document.querySelectorAll('.header__search.header__search-btn');
    const searchBtn = document.querySelectorAll('.header-wrapper .desktop-search-hero');
    const searchBtnDesktop = document.querySelector('header .desktop-search-hero');
    const mobileBreakpoint = 767;
    const desktopScrollThreshold = 500;
    const mobileScrollThreshold = 300;
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const scrollThreshold = window.innerWidth <= mobileBreakpoint ? mobileScrollThreshold : desktopScrollThreshold;
    const homepageBody = document.querySelector('body.template-index');
    const searchInput = document.querySelector('.header-wrapper .mobile input.hero-search-input');
    
    if (homepageBody) {
        if (scrollPosition > scrollThreshold) {
            searchBtn.forEach((button) => {
                button.classList.add('visible-search');
            })
            searchBtnDesktop.classList.add('visible-search');
        } else {
            searchBtn.forEach((button) => {
                button.classList.remove('visible-search');
            })
            searchBtnDesktop.classList.remove('visible-search');
        }
    } else {
        searchBtn.forEach((button) => {
            button.classList.add('visible-search');
        })
        searchBtnDesktop.classList.add('visible-search');
    }
}
function handleSearchVisibilityDesktop() {
    const searchBtn = document.querySelectorAll('.header__search.header__search-btn');
    // const searchBtn = document.querySelectorAll('.header-wrapper .desktop-search-hero')
    const mobileBreakpoint = 767;
    const desktopScrollThreshold = 500;
    const mobileScrollThreshold = 300;
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const scrollThreshold = window.innerWidth <= mobileBreakpoint ? mobileScrollThreshold : desktopScrollThreshold;
    if (scrollPosition > scrollThreshold) {
        searchBtn.forEach((button) => {
            button.classList.add('visible-search');
        })
    } else {
        searchBtn.forEach((button) => {
            button.classList.remove('visible-search');
        })
    }
}
window.addEventListener('scroll', handleSearchVisibility);
document.addEventListener('DOMContentLoaded', handleSearchVisibility);

window.addEventListener('scroll', handleSearchVisibilityDesktop);
document.addEventListener('DOMContentLoaded', handleSearchVisibilityDesktop);



function updateInputStyle() {
    const input = document.getElementById("wsg-search-input");
    const svgPath = document.querySelector(".wsg-search-button svg path");
    const eyeSvg = document.querySelector("svg.wsg-eye path");
    const numberInput = document.querySelector('input[type="number"].quantity.field');
    const schemeAttribute = document.body.getAttribute("data-scheme");
    const isDarkMode = schemeAttribute === "dark";

    if (input && svgPath && eyeSvg && numberInput) {
        const color = isDarkMode ? "rgb(255, 255, 255)" : "#200323";
        
        input.style.borderColor = `${color} !important`;
        input.style.color = `${color} !important`;
        numberInput.style.borderColor = `${color} !important`;
        numberInput.style.color = `${color} !important`;
        svgPath.style.fill = `${color} !important`;
        eyeSvg.style.fill = `${color} !important`;
}
}
// Initial call on page load
updateInputStyle();

// Event listener for scheme toggle
document.querySelector(".header__toggle-scheme").addEventListener("change", () => {
    setTimeout(updateInputStyle, 1000);
});

  // Dynamic threshold for showing the modal
const bulkPricingThreshold = 5; 
function checkCartItemCount() {
    const items = this.querySelectorAll(".cart-item-class"); 
    let totalCount = 0;

    items.forEach(item => {
        const quantity = parseInt(item.querySelector('.item-quantity').value) || 0; 
        totalCount += quantity; // Sum the quantities
    });

    const bulkPricingThreshold = 5;

    if (totalCount >= bulkPricingThreshold) {
        const event = new CustomEvent('bulk:eligible');
        document.dispatchEvent(event);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    // Get all instances of the reusable search snippet 
    const searchSnippets = document.querySelectorAll('section.slideshow-with-search .desktop-search-hero');
if (searchSnippets) {
    searchSnippets.forEach((searchSnippet) => {
        const searchInput = searchSnippet.querySelector('.search-input');
        const resultsContainer = searchSnippet.querySelector('.predictive-search-results');
        const sectionWrapper = searchSnippet.closest('section.slideshow-with-search');
        const searchForm = searchSnippet.querySelector('.hero-banner__search-form');
        const submitButton = searchSnippet.querySelector('.search-button');
        const categoryDropdown = searchSnippet.querySelector('.category-dropdown__select');


        searchInput.addEventListener('input', function () {
            const query = searchInput.value.trim();
            const selectedCategory = categoryDropdown.value;
            let url;

            if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                url = `/en/search/suggest.json?q=${query}&resources[type]=product&filter=${selectedCategory}`;
            } else {
                url = `/search/suggest.json?q=${query}&resources[type]=product&filter=${selectedCategory}`;
            }
            if (query.length > 2) {
                searchInput.classList.add('active');
                fetch(url)
                    .then(response => response.json())
                    .then(data => displayResults(data.resources.results.products.slice(0, 3)))
                    .catch(error => console.error('Error fetching predictive search results:', error));
            } else {
                resultsContainer.classList.remove('active');
                searchInput.classList.remove('active');
                sectionWrapper?.classList.remove('active');
                resultsContainer.innerHTML = '';
            }
        });

        function displayResults(products) {
            if (products.length === 0) {
                resultsContainer.classList.remove('active');
                sectionWrapper?.classList.remove('active');
                resultsContainer.innerHTML = '<p>Aucun résultat trouvé</p>';
                return;
            }

            const items = products.map(product => `
                <li>
                    <a href="${product.url}">
                        ${product.title}
                    </a>
                </li>
            `).join('');
            const query = searchInput.value.trim();
            if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                resultsContainer.innerHTML = `
                <ul>${items}</ul>
                <a class='search__button button button--primary hero-search' href='/en/search?q=${query}&collection=${categoryDropdown.value}'>
                    <span>Search</span>
                    <svg class="icon icon-button-arrow" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.33716 3.345L2.16466 10.5175L0.986328 9.33917L8.15799 2.16667H1.83716V0.5H11.0038V9.66667H9.33716V3.345Z" fill="currentColor"></path>
                    </svg>
                </a>`;
            } else {
                resultsContainer.innerHTML = `
                <ul>${items}</ul>
                <a class='search__button button button--primary hero-search' href='/search?q=${query}&collection=${categoryDropdown.value}'>
                    <span>Recherche</span>
                    <svg class="icon icon-button-arrow" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.33716 3.345L2.16466 10.5175L0.986328 9.33917L8.15799 2.16667H1.83716V0.5H11.0038V9.66667H9.33716V3.345Z" fill="currentColor"></path>
                    </svg>
                </a>`;
            }

            resultsContainer.classList.add('active');
            sectionWrapper?.classList.add('active');
        }

        // Prevent default form submission
        searchForm.addEventListener('submit', function (event) {
            event.preventDefault();
            const query = searchInput.value.trim();
            const selectedCategory = categoryDropdown ? categoryDropdown.value : '';
            
            const encodedCategory = encodeURIComponent(selectedCategory);
            if (query.length > 2) {
                if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                window.location.href = `/en/search?q=${query}&filter.p.product_type=${encodedCategory}`;
                } else {
                    window.location.href = `/search?q=${query}&filter.p.product_type=${encodedCategory}`;
                }
            } else {
                if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                    window.location.href = `/en/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                } else {
                    window.location.href = `/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                }
            }
        });

        // Handle Enter key press in search input
        searchInput.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault();
                const query = searchInput.value.trim();
                const selectedCategory = categoryDropdown ? categoryDropdown.value : '';
                const encodedCategory = encodeURIComponent(selectedCategory);
                if (query.length > 2) {
                    if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                        window.location.href = `/en/search?q=${query}&filter.p.product_type=${encodedCategory}`;
                    } else {
                        window.location.href = `/search?q=${query}&filter.p.product_type=${encodedCategory}`;
                    }
                } else {
                    if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                        window.location.href = `/en/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                    } else {
                        window.location.href = `/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                    }
                }
            }
        });

        // Handle button click
        submitButton.addEventListener('click', function (event) {
            event.preventDefault();
            const query = searchInput.value.trim();
            const selectedCategory = categoryDropdown ? categoryDropdown.value : '';
            const encodedCategory = encodeURIComponent(selectedCategory);

            if (query.length > 2) {
                if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                window.location.href = `/en/search?q=${query}&filter.p.product_type=${encodedCategory}`;
                } else {
                    window.location.href = `/search?q=${query}&filter.p.product_type=${encodedCategory}`;
                }
            } else {
                if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                    window.location.href = `/en/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                } else {
                    window.location.href = `/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                }
            }
        });

        // Close the predictive search dropdown when clicking outside
        document.addEventListener('click', function (event) {
            if (!resultsContainer.contains(event.target) && !searchInput.contains(event.target)) {
                resultsContainer.classList.remove('active');
                sectionWrapper?.classList.remove('active');
            }
        });
    });
}
});



// collection page character cutoff
document.addEventListener('DOMContentLoaded', function () {
    const collectionHeroWrapper = document.querySelector('.collection-hero__description');
    if (collectionHeroWrapper) {
        const descriptionContent = collectionHeroWrapper.querySelector('.description-content');
        const readMoreButton = collectionHeroWrapper.querySelector('.toggle-description-show');
        const readMoreButtonSpan = readMoreButton.querySelector('span');
        const transitionDuration = 500;
        let isExpanded = false;
    
        // Function to determine truncation limit based on screen width
        function getTruncationLimit() {
            return window.innerWidth <= 767 ? 125 : 500; 
        }
    
        // Function to update the displayed text and button visibility
        function updateText() {
            const truncationLimit = getTruncationLimit();
            const truncatedText = fullText.slice(0, truncationLimit) + '...';
    
            if (fullText.length > truncationLimit) {
                descriptionContent.innerText = truncatedText;
                readMoreButton.style.display = 'inline-block'; // Show the button if text is truncated
            } else {
                descriptionContent.innerText = fullText;
                readMoreButton.style.display = 'none'; // Hide the button if no truncation is needed
            }
        }
    
        // Get the full text
        const fullText = descriptionContent.innerText.trim();
    
        // Initial setup
        updateText();
    
        // Re-check and update text on window resize
        window.addEventListener('resize', updateText);
    
        // Toggle between expanded and truncated text on button click
        readMoreButton.addEventListener('click', function () {
            if (isExpanded) {
                descriptionContent.classList.remove('expanded');
    
                setTimeout(() => {
                    if (!isExpanded) {
                        readMoreButtonSpan.innerText = 'Afficher plus';
                        updateText();
                    }
                }, transitionDuration);
            } else {
                descriptionContent.innerText = fullText;
                descriptionContent.classList.add('expanded');
                readMoreButtonSpan.innerText = 'Afficher moins';
            }
            isExpanded = !isExpanded;
        });
    }
    
    


    // update header search placeholder 
    const headerSearch = document.querySelector('.mobile input.hero-search-input');
    if (headerSearch) {
        headerSearch.setAttribute('placeholder', 'Chercher...');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.querySelector('section.slideshow-with-search input.hero-search-input');
    const mobileBreakpoint = 767;

    if (!searchInput) {
        console.error('Search input not found. Check the selector.');
        return;
    }

    function updatePlaceholder() {
        const windowWidth = window.innerWidth;

        if (windowWidth <= mobileBreakpoint) {
            searchInput.setAttribute('placeholder', '');
        } else {
            searchInput.setAttribute('placeholder', '');
        }
    }
    updatePlaceholder();
    window.addEventListener('resize', updatePlaceholder);
});



document.addEventListener('DOMContentLoaded', function () {
    const dropdowns = document.querySelectorAll('.custom-dropdown');

    dropdowns.forEach(dropdown => {
        const button = dropdown.querySelector('.dropdown-button');
        const options = dropdown.querySelector('.dropdown-options');
        const select = dropdown.nextElementSibling; // Hidden `<select>`
        const inputWrapper = document.querySelectorAll('.hero-search-input');

        // Toggle dropdown visibility
        button.addEventListener('click', function () {
            options.classList.toggle('active');
            button.classList.toggle('active');
            inputWrapper.forEach((wrapper) => {
                wrapper.classList.remove('active');
            })
            // inputWrapper.classList.remove('active');
        });
       
        // Handle option selection
        options.addEventListener('click', function (event) {
            inputWrapper.forEach((wrapper) => {
                wrapper.classList.remove('active');
            })
            const clickedOption = event.target.closest('li');
            if (clickedOption) {
                const value = clickedOption.dataset.value;
                const label = clickedOption.textContent;

                // Update button label
                button.textContent = label;

                // Update hidden <select>
                select.value = value;

                // Close the dropdown
                options.classList.remove('active');
            }
        });

        // Close dropdown on outside click
        document.addEventListener('click', function (event) {
            if (!dropdown.contains(event.target)) {
                options.classList.remove('active');
                button.classList.remove('active');
            }
        });
    });

    const collectionFilters = document.querySelectorAll('#FacetFiltersForm details');
    if (collectionFilters) {
        collectionFilters.forEach((filter) => {
            const spanLabel = filter.querySelector('span.facets__underline');
            if (spanLabel && spanLabel.innerHTML.includes('Collection')){
                filter.classList.add('collections-filter');
            }
        })
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const inputWrapper = document.querySelector('.input-wrapper');
    const input = inputWrapper.querySelector('input');
  
    // Add 'focused' class when input gains focus
    input.addEventListener('focus', function () {
      if (input.matches(':focus-visible')) {
        inputWrapper.classList.add('focused');
      }
    });
  
    // Remove 'focused' class when input loses focus
    input.addEventListener('blur', function () {
      inputWrapper.classList.remove('focused');
    });
  });
  
  document.addEventListener('DOMContentLoaded', function () {
    const searchSnippets = document.querySelectorAll('.desktop-search-hero:not(section.slideshow-with-search .desktop-search-hero');

    searchSnippets.forEach((searchSnippet) => {
        const searchInput = searchSnippet.querySelector('.search-input');
        const resultsContainer = searchSnippet.querySelector('.predictive-search-results');
        const searchForm = searchSnippet.querySelector('.hero-banner__search-form');
        const submitButton = searchSnippet.querySelector('.search-button');
        const categoryDropdown = searchSnippet.querySelector('.category-dropdown__select');
        const customDropdownOptions = searchSnippet.querySelector('.dropdown-options');

        let uniqueProductTypes = [];

        // Event listener for the search input
        searchInput.addEventListener('input', function () {
            const query = searchInput.value.trim();
            if (query.length > 2) {
                searchInput.classList.add('active');
                fetchSearchResults(query, categoryDropdown.value);
            } else {
                resultsContainer.classList.remove('active');
                searchInput.classList.remove('active');
                resultsContainer.innerHTML = '';
            }
        });

        // Event listener for the category dropdown
// Event listener for dropdown selection change
categoryDropdown.addEventListener('change', function () {
    const query = searchInput.value.trim();
    const selectedCategory = categoryDropdown.value; // Get the selected category
let url;
    // Only perform fetch if query is valid
    if (query.length > 2) {
        if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
            url = `/en/search/suggest.json?q=${query}&resources[type]=product,collection,page${
                selectedCategory ? `&collection=${encodeURIComponent(selectedCategory)}` : ''
            }`;
        } else {
            url = `/search/suggest.json?q=${query}&resources[type]=product,collection,page${
                selectedCategory ? `&collection=${encodeURIComponent(selectedCategory)}` : ''
            }`;
        }
        

        // Perform the fetch directly
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.json();
            })
            .then(data => {
                const results = data.resources.results.slice(0,4);
                displayResults(results, query, selectedCategory);
            })
            .catch(error => {
                console.error("Error fetching predictive search results:", error);
            });
    }
});


// Function to fetch search results based on query and category
function fetchSearchResults(query, category) {
    let url;
    if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
        url = `/en/search/suggest.json?q=${query}&resources[type]=product,collection,page&collection=${category}`;
    } else {
        url = `/search/suggest.json?q=${query}&resources[type]=product,collection,page&collection=${category}`;
    }

    fetch(url)
        .then(response => response.json())
        .then(data => {
            return data.resources.results;
        })
        .then(results => {
            updateProductTypeDropdown(results.products.slice(0,4) || []);
            displayResults(results, query, category);
        })
        .catch(error => console.error('Error fetching predictive search results:', error));
}

// Function to update the product types in the dropdown
function updateProductTypeDropdown(products) {
    const productTypes = products.map(product => product.type).filter(Boolean);

    if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')) {
       
    }
    const newUniqueTypes = [...new Set(productTypes)];

    if (JSON.stringify(newUniqueTypes) !== JSON.stringify(uniqueProductTypes)) {
        uniqueProductTypes = newUniqueTypes;
        customDropdownOptions.innerHTML = `
            <li data-value="">Tous</li>
            ${uniqueProductTypes
                .map(type => `<li data-value="${type}">${type}</li>`)
                .join('')}
        `;

        categoryDropdown.innerHTML = `
            <option value="">Tous</option>
            ${uniqueProductTypes
                .map(type => `<option value="${type}">${type}</option>`)
                .join('')}
        `;
        setupDropdownBehavior();
    }
}

// Function to display the search results
function displayResults(results, query, category) {
    const { products = [], collections = [], pages = [] } = results;
    const brokenImage = `https://cdn.shopify.com/s/files/1/0872/1976/5566/files/Group11_2.svg?v=1732066949`;
    const arrowSVG = `<svg class="search-arrow" xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
    <rect x="0.5" y="1.00003" width="39" height="39" rx="19.5" stroke="#1F0322"/>
    <g clip-path="url(#clip0_1208_176)">
    <path d="M23.3372 18.345L16.1647 25.5175L14.9863 24.3392L22.158 17.1667H15.8372V15.5H25.0038V24.6667H23.3372V18.345Z" fill="#1F0322"/>
    </g>
    <defs>
    <clipPath id="clip0_1208_176">
    <rect width="12" height="11" fill="white" transform="translate(14 15)"/>
    </clipPath>
    </defs>
    </svg>`
    // Filter products by category if one is selected
    const filteredProducts = category 
        ? results.products.filter(product => {
              return product.type === category;
          })
        : results.products;

    // Limit the results to the first 4 for each category
    const limitedProducts = filteredProducts.slice(0, 4); // Max 4 products
    const limitedCollections = collections.slice(0, 4);  // Max 4 collections
    const limitedPages = pages.slice(0, 4);              // Max 4 pages

    // Product items
    const productItems = limitedProducts.map(product => `
        <div class="grid-item product">
            <a href="${product.url}">
                <img src="${product.featured_image?.url || brokenImage}" alt="${product.title}" />
                <div class="right">   
                <div class="info-wrapper">
                    <p class="title">${product.title}</p>
                    <p class="price">${product.price}</p>
                    </div>
                    ${arrowSVG}
                </div>
            </a>
        </div>
    `).join('');

    // Collection items
    const collectionItems = limitedCollections.map(collection => `
        <div class="grid-item collection">
            <a href="${collection.url}">
                <img src="${collection.featured_image?.url || brokenImage}" alt="${collection.title}" />
                <div class="right"> 
                <div class="info-wrapper">
                    <p class="title">${collection.title}</p>
                </div>
                ${arrowSVG}
                </div>
            </a>
        </div>
    `).join('');

    // Page items
    const pageItems = limitedPages.map(page => `
        <div class="grid-item page">
            <a href="${page.url}">
            <img src="${brokenImage}" alt="${page.title}" />
            <div class="right"> 
                <div class="info-wrapper">
                    <p class="title">${page.title}</p>
                </div>
                ${arrowSVG}
                </div>
            </a>
        </div>
    `).join('');

    // Update results container with filtered results
    if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
        resultsContainer.innerHTML = `
        <div class="category-buttons-container">
            <button class="category-button active" data-category="products">Products</button>
            <button class="category-button" data-category="collections">Collections</button>
            <button class="category-button" data-category="pages">Pages</button>
        </div>
        <div class="grid-section" data-category="products">
            <div class="grid">${productItems || '<p class="none-found">No products found</p>'}</div>
        </div>
        <div class="grid-section" data-category="collections" style="display: none;">
            <div class="grid">${collectionItems || '<p class="none-found">No collection found</p>'}</div>
        </div>
        <div class="grid-section" data-category="pages" style="display: none;">
            <div class="grid">${pageItems || '<p class="none-found">No page found</p>'}</div>
        </div>
        <a class='search__button button button--primary hero-search' href='/en/search?q=${query}&collection=${category}'>
            <span>Search</span>
            <svg class="icon icon-button-arrow" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.33716 3.345L2.16466 10.5175L0.986328 9.33917L8.15799 2.16667H1.83716V0.5H11.0038V9.66667H9.33716V3.345Z" fill="currentColor"></path>
        </svg>
        </a>
    `;
    } else {
    resultsContainer.innerHTML = `
        <div class="category-buttons-container">
            <button class="category-button active" data-category="products">Produits</button>
            <button class="category-button" data-category="collections">Collections</button>
            <button class="category-button" data-category="pages">Pages</button>
        </div>
        <div class="grid-section" data-category="products">
            <div class="grid">${productItems || '<p class="none-found">Aucun produit trouvé</p>'}</div>
        </div>
        <div class="grid-section" data-category="collections" style="display: none;">
            <div class="grid">${collectionItems || '<p class="none-found">Aucune collection trouvée</p>'}</div>
        </div>
        <div class="grid-section" data-category="pages" style="display: none;">
            <div class="grid">${pageItems || '<p class="none-found">Aucune page trouvée</p>'}</div>
        </div>
        <a class='search__button button button--primary hero-search' href='/search?q=${query}&collection=${category}'>
            <span>Recherche</span>
            <svg class="icon icon-button-arrow" width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.33716 3.345L2.16466 10.5175L0.986328 9.33917L8.15799 2.16667H1.83716V0.5H11.0038V9.66667H9.33716V3.345Z" fill="currentColor"></path>
        </svg>
        </a>
    `;
    }
    resultsContainer.classList.add('active');
    
    setupCategoryFiltering();
}


        
        
        
        // Function to setup dropdown behavior (if needed)
        function setupDropdownBehavior() {
            // Implement logic to toggle dropdown visibility or other behaviors as necessary
        }

        // Function to handle category button filtering
        function setupCategoryFiltering() {
            const categoryButtons = resultsContainer.querySelectorAll('.category-button');
            categoryButtons.forEach(button => {
                button.addEventListener('click', function () {
                    const category = button.getAttribute('data-category');
                    displayResults({ products, collections, pages }, query, category);
                });
            });
        }


        function setupDropdownBehavior() {
            const dropdownItems = customDropdownOptions.querySelectorAll('li');
            dropdownItems.forEach(item => {
                item.addEventListener('click', () => {
                    const selectedValue = item.getAttribute('data-value');
                    categoryDropdown.value = selectedValue; // Update the hidden select
                    customDropdownOptions.querySelectorAll('li').forEach(li => li.classList.remove('active'));
                    item.classList.add('active'); // Highlight selected option
        
                    // Trigger a new fetch with updated category
                    const query = searchInput.value.trim();
                    if (query.length > 2) {
                        fetchSearchResults(query, selectedValue);
                    }
                });
            });
        }
        

        function setupCategoryFiltering() {
            const categoryButtons = resultsContainer.querySelectorAll('.category-button');
            const gridSections = resultsContainer.querySelectorAll('.grid-section');

            categoryButtons.forEach(button => {
                button.addEventListener('click', () => {
                    categoryButtons.forEach(btn => btn.classList.remove('active'));
                    button.classList.add('active');

                    const selectedCategory = button.getAttribute('data-category');
                    gridSections.forEach(section => {
                        section.style.display = section.getAttribute('data-category') === selectedCategory ? 'block' : 'none';
                    });
                });
            });
        }

        searchForm.addEventListener('submit', handleSearchSubmit);
        submitButton.addEventListener('click', handleSearchSubmit);

        function handleSearchSubmit(event) {
            event.preventDefault();
            const query = searchInput.value.trim();
            const selectedCategory = categoryDropdown.value || '';
            if (query.length > 2) {
                if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                    window.location.href = `/en/search?q=${query}&filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                } else {
                    window.location.href = `/search?q=${query}&filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                }
                
            } else {
                if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                    window.location.href = `/en/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                } else {
                    window.location.href = `/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
                }
            }
        }

        document.addEventListener('click', function (event) {
            if (!resultsContainer.contains(event.target) && !searchInput.contains(event.target)) {
                resultsContainer.classList.remove('active');
            }
        });
    });
});


document.addEventListener("DOMContentLoaded", function () {
    const input = document.getElementById("search-input");
    const customPlaceholder = document.getElementById("custom-placeholder");
    customPlaceholder.style.opacity = "1";
    // Fade out the placeholder when input is focused
    input.addEventListener("focus", function () {
      customPlaceholder.style.opacity = "0";
    });
  
    // Fade the placeholder back in if the input is empty
    input.addEventListener("blur", function () {
      if (!input.value) {
        customPlaceholder.style.opacity = "1";
      }
    });
  
    // If the input has text on load, fade the placeholder out
    if (input.value) {
      customPlaceholder.style.opacity = "0";
    }
  });
  document.addEventListener('DOMContentLoaded', function() {
    const productDropdowns = document.querySelectorAll('.product-parameters .product-form__input');

    if (productDropdowns){
    const newClass = 'product-dropdowns-' + productDropdowns.length;
        document.body.classList.add(newClass)
    }

    const modalButtons = document.querySelectorAll('modal-opener button');
    if (modalButtons) {
        modalButtons.forEach((button)=> {
            button.addEventListener('click', function() {
                setTimeout(() => {
                    const modals = document.querySelectorAll('quick-add-modal');
                    if (modals){
                        modals.forEach((modal) => {
                            const dropDowns = modal.querySelectorAll('.product-parameters .product-form__input');
                            if (dropDowns) {
                                const newModalClass = 'product-dropdowns-' + dropDowns.length;
                                modal.classList.add(newModalClass);
                            }
                        });
                    }
                }, 700)
            })
        })
    }

  })


  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(()=>{
    const wishlistHeartNav = document.querySelectorAll('wk-icon.wk-icon[icon="wishlist"]');
    
    if (wishlistHeartNav.length > 0) {

        // Loop through all matching wishlist icons
        wishlistHeartNav.forEach(function(link) {
            // Get the SVG element inside the wishlist-link
            const svgElement = link.querySelector('svg'); // Assumes there is an <svg> tag inside the wishlist link
            
            if (svgElement) {

                // Modify the SVG's attributes or style (example: change fill color)
                svgElement.setAttribute('fill', '#FF0000'); // Change to red as an example
                
                // Alternatively, you can replace the entire SVG content if needed
                svgElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1" viewBox="0 0 16.2 14.4">
                <defs>
                  <style>
                  body[data-scheme="light"] .st0,
                  body[data-scheme="dark"] .card--product .wk-button:not(.wk-selected ) .st0
                  {
                      fill: none;
                      stroke: #1f0322;
                      stroke-miterlimit: 10;
                      stroke-width: 1.4px;
                    }
                    body[data-scheme="light"] wishlist-link-floating .st0 {
                        stroke: white;
                      }
                body[data-scheme="dark"] .st0 {
                    fill: none;
                    stroke: white;
                    stroke-miterlimit: 10;
                    stroke-width: 1.4px;
                }
                .card--product .wk-button:not(.wk-selected ) .st0 {
                    stroke: #1f0322!important;
                }
                  </style>
                </defs>
                <path class="st0" d="M4.5,11.4C2.1,9.5.7,7.3.7,4.8S2.5.7,4.7.7s2,.4,2.8,1.2l.7.7.7-.7c.7-.7,1.7-1.2,2.8-1.2,2.2,0,4,1.8,4,4.1,0,2.5-1.4,4.6-3.8,6.6-.4.3-3.6,2.2-3.6,2.2,0,0-3.2-1.9-3.6-2.2h0Z"/>
              </svg>`;
            }
        });
    } else {
        console.log('Wishlist icon not found');
    }
}, 1000)
});

document.addEventListener('DOMContentLoaded', function () {
    const menuDrawer = document.querySelector('details.menu-drawer-container.menu-opening');
    const body = document.body;
  
    // Function to check for the "menu-opening" class and toggle "nav-open"
    const toggleNavClass = () => {
      if (menuDrawer && menuDrawer.classList.contains('menu-opening')) {
        body.classList.add('nav-open');
      } else {
        body.classList.remove('nav-open');
      }
    };
  
    // Initial check in case the class is already present
    toggleNavClass();
  
    // Observe the element for changes to the class
    const observer = new MutationObserver(toggleNavClass);
  
    // Start observing the element for class changes
    observer.observe(menuDrawer, {
      attributes: true,    // Watch for attribute changes
      attributeFilter: ['class'],  // Only track changes to the 'class' attribute
    });
  });
  
  document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.header__offcanvas-item');
  
    menuItems.forEach((menuItem) => {
      const submenu = menuItem.querySelector('.header__offcanvas-submenu');
  
      if (submenu) {
        // Add a class to indicate that the item is expandable
        menuItem.classList.add('has-submenu');
  
        // Add a click event listener to toggle the submenu
        menuItem.querySelector('.header__offcanvas-link').addEventListener('click', (event) => {
          event.preventDefault();
  
          // Toggle active class
          menuItem.classList.toggle('submenu-open');
  
          // Slide toggle the submenu
          if (menuItem.classList.contains('submenu-open')) {
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
          } else {
            submenu.style.maxHeight = 0;
          }
        });
      }
    });

    if (window.innerWidth <= 767) {
        const sectionSearch = document.querySelector('section.slideshow-with-search #custom-placeholder');
        if (sectionSearch) {
            sectionSearch.style.opacity = 1;
        }
    }

    const searchInput = document.querySelector('section.slideshow-with-search #search-input');
    const customPlaceholder = document.querySelector('section.slideshow-with-search #custom-placeholder');

    if (window.innerWidth <= 767 && customPlaceholder) {
      customPlaceholder.style.opacity = 1; // Set initial opacity for small screens

      // Add event listeners to handle focus and blur
      searchInput.addEventListener('focus', () => {
        customPlaceholder.style.opacity = 0;
      });

      searchInput.addEventListener('blur', () => {
        if (!searchInput.value) {
          customPlaceholder.style.opacity = 1;
        }
      });
    }
  });
  

  document.addEventListener("DOMContentLoaded", () => {
    const searchInput = document.getElementById("search-input");
    const dropdownOptions = document.querySelectorAll(".dropdown-options li");
    const dropdownButton = document.querySelector(".dropdown-button");
    const searchForm = document.querySelector(".hero-banner__search-form");

    // Helper to update the button text and data value
    const updateDropdownSelection = (selectedOption) => {
        dropdownButton.textContent = selectedOption.textContent;
        dropdownButton.dataset.value = selectedOption.dataset.value;
    };

    // Handle dropdown selection
    dropdownOptions.forEach(option => {
        option.addEventListener("click", () => {
            updateDropdownSelection(option);
        });
    });

    // Handle form submission
     const searchFormButton = searchForm.querySelector('button[type="submit"]');

    searchFormButton.addEventListener("click", (event) => {
        const selectedCategory = dropdownButton.dataset.value || ""; 
        const searchValue = searchInput.value.trim(); 
        if (!searchValue && selectedCategory) {
            event.preventDefault(); 
            if (window.location.href.includes('/en/') || window.location.href.includes('.com/en')){
                window.location.href = `/en/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
            } else {
                window.location.href = `/collections/produits?filter.p.product_type=${encodeURIComponent(selectedCategory)}`;
            }
        }
    });


 
    const buttons = document.querySelectorAll('.template-product-escaliers .escaliers-pdp');
    const contactForm = document.querySelector('div.contact');

    if (buttons && contactForm) {
        buttons.forEach((button) => {
            button.addEventListener("click", function(e) {
                e.preventDefault(); 
                const rect = contactForm.getBoundingClientRect();
                const isMobile = window.innerWidth <= 767; 
                const offset = isMobile ? 160 : 150;
                const targetPosition = rect.top + window.pageYOffset - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            });
        });
    };
    
    const escaliersAccordion = document.querySelector('.template-product-escaliers .accordion details:nth-of-type(1)');
    if (escaliersAccordion) {
        escaliersAccordion.setAttribute('open', '');
    }


});


document.addEventListener('DOMContentLoaded', function() {
    const autoAccordion = document.querySelectorAll('.accordion.auto-options');
    autoAccordion.forEach((accordion) => {
        const header = accordion.querySelector('h5.h5');
        const content = accordion.querySelector('div.product__description.quick-add-hidden li');
        if (header.innerHTML.includes('Title') && content.innerHTML.includes('Default Title')){
            accordion.classList.add('custom-accordion-hidden');
        }
    });

    const cartPageItems = document.querySelectorAll('.template-cart .cart-item');
    if (cartPageItems) {
        cartPageItems.forEach((item) => {
            const itemImage = item.querySelector('.cart-item__image');
            const itemRows = item.querySelectorAll('.product-option');
            itemRows.forEach((row) => {
                const itemRowDDElements = row.querySelectorAll('dd');
                itemRowDDElements.forEach((element) => {
                    if (element.innerHTML.includes('www.')) {
                        row.style.display = 'none';
                        const replacementUrl = '//' + element.innerHTML;
                        itemImage.attributes.src.value = replacementUrl;
                    }
                });
            })
        })
    }
})